import React from 'react';
import type { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import { Item, Content } from './components';
import { ItemVariant, listVariants } from './IconLinkList.motion';

import './IconLinkList.scss';

export interface IconLinkListProps {
    children: ReactNode;
}

export function IconLinkList({ children }: IconLinkListProps) {
    return (
        <motion.ul
            className="IconLinkList"
            variants={listVariants}
            initial={ItemVariant.Initial}
            animate={ItemVariant.Show}
        >
            <AnimatePresence>{children}</AnimatePresence>
        </motion.ul>
    );
}

IconLinkList.Item = Item;
IconLinkList.Content = Content;
